// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nu-3";
export var downloadButton = "_nu-4";
export var fileContainer = "_nu-9 _nu-7";
export var fileContainerBase = "_nu-7";
export var fileContainerFixedHeight = "_nu-8 _nu-7";
export var fileInfo = "_nu-5";
export var fileInfoWidthRestricted = "_nu-6";
export var fileType = "_nu-1";
export var fileTypeName = "_nu-2";
export var image = "_nu-0";
export var link = "_nu-b";
export var overflowEllipsis = "_nu-a";